import { watch } from 'vue';

import { chatbotToken } from '~/_v3/composables/useToken';

import { i18n } from '../vue-i18n';

export function initChatbot() {
	window.AGO = {
		basepath: 'https://silae.useago.com/',
		widgetApiKey: 'silae_public_key_AHUIUY678H',
		title: 'Assistant eDocPerso',
		icon: '/support-chatbot.svg',
		prompt: i18n.global.t('common.chatbot'),
		colors: {
			button: '#36567C',
			header: '#36567C'
		},
		...(chatbotToken.value && { jwt: chatbotToken.value })
	};

	// Load the frame script
	const agoFrame = document.createElement('script');
	agoFrame.setAttribute('src', 'https://useago.github.io/widgetjs/frame.js');
	document.body.appendChild(agoFrame);

	watch(
		() => chatbotToken.value,
		currentToken => {
			if (window.AGO) {
				currentToken?.length ? (window.AGO.jwt = currentToken) : delete window.AGO.jwt;
			}
		}
	);
}

export function updateAgoWidgetStyle() {
	const style = document.createElement('style');
	style.textContent = `
	  #ago-prompt {
	    bottom: 140px !important;
	  }
		#ago-chat-button {
			bottom: 80px !important
		}
	`;
	document.head.appendChild(style);
}
